import { HistoriaLaboral } from 'components/Experiencia'
import { Card, CardBody, CardLink, CardText, CardFooter } from 'reactstrap';
import React from 'react'
import { DownloadDocument } from 'helpers/files';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';

type PropsCardHistoriaLaboralDP = {
    datosExperiencia: HistoriaLaboral,
    valorTotal: number,
    numeroCard: number
}

export default function CardHistoriaLaboralDP(props: PropsCardHistoriaLaboralDP) {
    const datosUsuario: UserData = authenticationService.currentUserValue;
    return (
        <Card className="cardHistoriaLaboral">
            <CardBody>
                <CardText>
                    <b>{"ESCUELA SUPERIOR POLITECNICA DEL LITORAL"}</b>
                    <br />
                    <br />
                    <span className="spanCard">CARGO: </span>{props.datosExperiencia.cargo}
                    <br />
                    <span className="spanCard">TIPO DE RELACIÓN LABORAL: </span>{props.datosExperiencia.tipoRelacion}
                    <br />
                    <span className="spanCard">MODALIDAD LABORAL: </span>{props.datosExperiencia.tipoContrato}
                    <br />

                    {
                        props.datosExperiencia.numeroActaTransaccional !== null && props.datosExperiencia.numeroActaTransaccional !== "" &&
                        (
                            <>
                                <span className="spanCard">NÚMERO ACTA TRANSACCIONAL: </span>{props.datosExperiencia.numeroActaTransaccional}
                                <br />
                            </>

                        )
                    }

                    <span className="spanCard">DESDE: </span> {props.datosExperiencia.desde}
                    <br />
                    <span className="spanCard">HASTA: </span> {props.datosExperiencia.hasta}
                    <br />

                    {
                        props.datosExperiencia.tipoDedicacion !== "No Aplica" ?
                            <>
                                <span className="spanCard">TIEMPO DE DEDICACIÓN: </span>{props.datosExperiencia.tipoDedicacion}
                                <br />
                            </>
                            :
                            null
                    }
                    <span className="spanCard">REMUNERACIÓN: </span>{props.datosExperiencia.rmu}
                    <br />
                    {
                        props.datosExperiencia.fechaDesvinculacion !== "" &&
                        <>
                            <span className="spanCard">FECHA DESVINCULACIÓN: </span> {props.datosExperiencia.fechaDesvinculacion}
                            <br />
                        </>
                    }
                    {
                        props.datosExperiencia.tipoAccion !== null && props.datosExperiencia.tipoAccion !== undefined &&
                        <>
                            <span className="spanCard">ACCIÓN DE PERSONAL:  </span> {props.datosExperiencia.tipoAccion}

                        </>
                    }

                </CardText>
            </CardBody>
            <CardFooter className="text-muted">

                <div style={{ float: "left" }}>
                    {`${props.numeroCard}/${props.valorTotal}`}
                </div>
                <div style={{ float: "right" }}>
                    {
                        props.datosExperiencia.refarchivo && props.datosExperiencia.refarchivo !== "" &&
                        <CardLink>
                            <i
                                onClick={() => DownloadDocument(props.datosExperiencia.refarchivo, datosUsuario.token, "Contrato.pdf")}
                                className="fas fa-download clickable"
                                aria-hidden="true"
                                data-toggle="tooltip" data-placement="top" title="Descargar contrato"
                            />
                        </CardLink>
                    }

                </div>
            </CardFooter>
        </Card>
    )
}